var map = {
	"./d10-icon.svg": "1df7",
	"./d10.svg": "c7fb",
	"./d100-icon.svg": "e055",
	"./d100.svg": "ef65",
	"./d12-icon.svg": "8a0e",
	"./d12.svg": "796a",
	"./d2-icon.svg": "7e2f",
	"./d2.svg": "84fb",
	"./d20-icon.svg": "7411",
	"./d20.svg": "efe5",
	"./d4-icon.svg": "39c7",
	"./d4.svg": "a06a",
	"./d6-icon.svg": "3ed5",
	"./d6.svg": "4809",
	"./d8-icon.svg": "05d2",
	"./d8.svg": "1911",
	"./dp-icon.svg": "d2c5",
	"./dp.svg": "4d06",
	"./minus.svg": "e9b2",
	"./plus.svg": "8a37"
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 7);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | icons */ "icons").then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "8f5e";
module.exports = webpackAsyncContext;